export const CLIENT_TYPES = [
  { id: "osoba", label: "Osoby fizyczne", color: "#EF4444" },
  { id: "firma", label: "Firmy", color: "#3B82F6" },
  { id: "instytucja", label: "Instytucje", color: "#A855F7" },
];

export const clientType = (c) => (CLIENT_TYPES.some((x) => x.id === c?.client_type) ? c.client_type : "osoba");
export const clientTypeColor = (c) => CLIENT_TYPES.find((x) => x.id === clientType(c)).color;
export const isOrgType = (ct) => ct === "firma" || ct === "instytucja";
